import { Pdf } from "./schemas/pdf";
import { Point } from "./schemas/canvas-element";
import { createElementId, getUnixTimestampUTC } from "shared/util/utils";

export function placePdf(
  point: Point,
  fileId: string | number | null,
  uploadStatus: "in-progress" | "completed",
  width?: number,
  height?: number,
  totalPages: number = 1,
  pageToDisplay?: number,
  customName?: string
) {
  const pdfWidth = width || 400;
  const pdfHeight = height || 600;

  const id = createElementId();
  const pdf: Pdf = {
    x: point.x,
    y: point.y,
    fileId,
    width: pdfWidth,
    height: pdfHeight,
    rotate: 0,
    uploadStatus,
    uploadProgress: uploadStatus === "in-progress" ? 0 : 100,
    currentPage: pageToDisplay || 1,
    totalPages,
    pageToDisplay,
    customName,
    attachedConnectors: {},
    scaleX: 1,
    scaleY: 1,
    zIndexLastChangeTime: getUnixTimestampUTC(),
    flags: 0,
  };

  return { id, pdf };
}
